import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ChakraProvider, extendTheme, Box } from '@chakra-ui/react';
import Home from './pages/Home';
import DNSTool from './pages/DNSTool';
import SEOScraper from './pages/SEOScraper';
import LaunchChecklist from './pages/LaunchChecklist';
import MeetingNotes from './pages/MeetingNotes';

// Professional dark theme
const theme = extendTheme({
  config: {
    initialColorMode: 'dark',
    useSystemColorMode: false,
  },
  styles: {
    global: {
      body: {
        bg: '#0F1419',
        color: 'white',
      },
    },
  },
  colors: {
    brand: {
      500: '#7c3aed',
      600: '#6b2dc9',
    },
    accent: {
      500: '#ec4899',
      600: '#d63384',
    },
  },
});

function App() {
  return (
    <ChakraProvider theme={theme}>
      <Router>
        <Box minH="100vh" bg="#0F1419">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/dns" element={<DNSTool />} />
            <Route path="/seo-scraper" element={<SEOScraper />} />
            <Route path="/launch-checklist" element={<LaunchChecklist />} />
            <Route path="/meeting-notes" element={<MeetingNotes />} />
          </Routes>
        </Box>
      </Router>
    </ChakraProvider>
  );
}

export default App;
